import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import LookUpService from './LookUpService';
import LookUpTableModel from '../../Admin/model/LookUpTableModel';
import * as constant from '../../shared/util/constant'
import Logger from '../../shared/services/Logger';
import { toast } from 'react-toastify';
import AppContext from '../../shared/components/AppContext';
import { useConfirmationModalContext } from '../../shared/components/ModalConfirmationContext';

interface Props {
    reload: boolean
}

const LookUpSideBar = (props: Props) => {
    const [lookUpTables, setLookUpTables] = useState<LookUpTableModel[]>([]);
    const lookUpService = new LookUpService();
    const history = useHistory();    
    const lookupContext = useContext(AppContext);
    const modalContext = useConfirmationModalContext();
    const { tableId } = useParams<{ tableId: string | undefined }>();

    const initializeLookUpTables = async () => {
        try {
            let response = await lookUpService.getLookUpTables();
            let res = [];
            if (response.length > 0) {
                res = response.map((item) => ({
                    id: item.id,
                    attrCode: item.attrCode,
                    description: item.description
                }));
            }

            res.sort((a, b) => (a.description || '').localeCompare(b.description || ''));
            setLookUpTables(res);
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    const handleLookUpTableClick = async (lookUpTableId: string, lookUpTableName: string) => {
        lookUpTableName = lookUpTableName.replace(/[\/\\#]/g, '-');
        if (!lookupContext.formSavedStatus) {
            const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
            if (result) {
                lookupContext.formSavedStatus = true
                history.push(`/maintenance/lookuptables/${lookUpTableId}/${lookUpTableName}`)
            }
        }
        else {
            history.push(`/maintenance/lookuptables/${lookUpTableId}/${lookUpTableName}`)
        }
    }

    useEffect(() => {
        initializeLookUpTables();
    }, []);

    useEffect(() => {
        initializeLookUpTables();
    }, [props.reload]);

    return (
        <div className='roles-sidebar d-flex flex-column overflow-auto' style={{ height: 'calc(100vh - 56px - 67px)' }}>
            {
                lookUpTables.map((lookuptable) => (
                    <div
                        key={lookuptable.id}
                        className={`role-item p-2 border-bottom ${lookuptable.id === tableId ? 'active bg-light' : ''}`}
                        onClick={() => {
                            handleLookUpTableClick(lookuptable.id, lookuptable.description)
                        }}
                    >
                        {lookuptable.description}
                    </div>
                ))
            }
        </div>
    );
}
export default LookUpSideBar;